<template>
    <div id="home" class="px-2 text-center">
    
	    <teleport to="#route_title">
			<div class="flex gap-2 items-center">
				<span>-</span><span>Startseite</span>
			</div>
		</teleport>
	    
	    <div style="max-width:600px;" class="m-auto">
		    <div class="grid grid-cols-12 px-4">
			    
			    <div class="col-span-12 my-6 text-center"><div class="text-center"><img src="img/airleben2018_5.png" class="mx-auto" /></div></div>			    
			    
			    <router-link class="col-span-4 text-center p-3" to="/airlpt"><img class="m-auto" src="img/button_airlpt.png" /></router-link>
			    <router-link class="col-span-4 text-center p-3" to="/ldk"><img class="m-auto" src="img/button_ldk.png" /></router-link>			    
			    <router-link class="col-span-4 text-center p-3" to="/uc"><img class="m-auto" src="img/button_einheiten.png" /></router-link>
			    
			    <router-link class="col-span-4 text-center p-3" to="/dim"><img class="m-auto" src="img/button_dimenstionierung.png" /></router-link>
			    <router-link class="col-span-4 text-center p-3" to="/canal"><img class="m-auto" src="img/button_kanal.png" /></router-link>			    
			    <router-link class="col-span-4 text-center p-3" to="/tube"><img class="m-auto" src="img/button_rohr.png" /></router-link>
			    
			    <div class="col-span-2 text-center p-3"></div>
			    
			    <router-link class="col-span-4 text-center p-3" to="/montage"><img class="m-auto" src="img/button_montagerechner.png" /></router-link>			    
			    <router-link class="col-span-4 text-center p-3" to="/qr"><img class="m-auto" src="img/button_qr.png" /></router-link>
			    
		    </div>
	    </div> 
	    
	    <div class="flex justify-center w-full text-white text-center text-xl mt-4">
		    airleben 2026<br />airleben - Luftleitungsrechner
	    </div>
	  
    </div>
</template>

<script>

	export default {
        name: 'HomeView',
		props: {
			state: Object
		},
        components: {
    
        },
		methods: {
		
			test() {
				 
				var userLang = navigator.language || navigator.userLanguage; 
				alert ("The language is: " + userLang);
				
			}
			
		},
		computed: {
			navigator() { return JSON.stringify(navigator); }
		},
		mounted() {
			
			
			
		}
	}
	
</script>

<style lang="scss">
 
	#home {
		
	}

</style>